import { Injectable, inject, computed, Signal } from '@angular/core';
import { PermissionsService } from './permissions.service';
import { NAV_SECTIONS } from '../../constants/nav-sections.constants';
import { NavItem, NavSection } from '../../interfaces/ui/nav-item.interface';

@Injectable({ providedIn: 'root' })
export class NavAccessService {
  private permissions = inject(PermissionsService);

  visibleSections: Signal<NavSection[]> = computed(() =>
    NAV_SECTIONS.map((section) => ({
      ...section,
      items: section.items.filter((item) => this.isVisible(item)),
    })).filter((section) => section.items.length > 0),
  );

  firstAllowedPath(): string {
    return this.visibleSections()[0]?.items[0]?.route ?? '/profile';
  }

  private isVisible(item: NavItem): boolean {
    if (item.permissions)
      return this.permissions.canAnySignal(item.permissions)();
    if (item.permission) return this.permissions.canSignal(item.permission)();
    return true;
  }
}
